import { useMemo, useCallback, useEffect } from 'react';
import { SimulatorProvider } from '@creditas-lab/simulator';
import { ThemeProvider as LegacyThemeProvider } from '@creditas/stylitas';
import tokenLegacy from '@creditas/tokens';
import tokenLegacyNew from '@creditas/tokens/dist/new-version';
import tokenLegacyFonts from '@creditas-lab/tokens';
import { useSimulator } from '@creditas-lab/simulator';
import {
  redirectToLeadReviewAuto,
  redirectToLeadFormAuto,
  redirectToLeadReviewHome,
  redirectToLeadFormHome,
} from '@/utils/redirect';
import { useGetAvailableLeadReview } from '@/hooks/queries/useGetAvailableLeadReview';

const Listener = (): JSX.Element => {
  const { openSimulator: open } = useSimulator();

  const handleOpenSimulator = useCallback(() => {
    open(0, null);
  }, [open]);

  useEffect(() => {
    window.addEventListener('openSimulator', handleOpenSimulator);

    return () => {
      window.removeEventListener('openSimulator', handleOpenSimulator);
    };
  }, [handleOpenSimulator]);

  return <></>;
};

const Simulator = (): JSX.Element => {
  const availableLeadReviewAuto = useGetAvailableLeadReview('auto');
  const availableLeadReviewHome = useGetAvailableLeadReview('home');

  const canReviewAuto = useMemo(() => {
    let canReview = false;
    if (availableLeadReviewAuto.data) {
      const { reviewButton } = availableLeadReviewAuto.data;
      canReview = reviewButton;
    }

    return canReview;
  }, [availableLeadReviewAuto]);

  const canReviewHome = useMemo(
    () => availableLeadReviewHome.data?.reviewButton,
    [availableLeadReviewHome],
  );

  const redirectAuto = useCallback(
    (intendedCredit: string): void => {
      if (canReviewAuto) {
        redirectToLeadReviewAuto();
        return;
      }

      redirectToLeadFormAuto(intendedCredit);
    },
    [canReviewAuto],
  );

  const redirectHome = useCallback(
    (intendedCredit: string): void => {
      if (canReviewHome) {
        redirectToLeadReviewHome();
        return;
      }

      redirectToLeadFormHome(intendedCredit);
    },
    [canReviewHome],
  );

  return (
    <LegacyThemeProvider theme={{ ...tokenLegacy, ...tokenLegacyNew, ...tokenLegacyFonts }}>
      <SimulatorProvider
        overrideRedirectToAuto={redirectAuto}
        overrideRedirectToHome={redirectHome}
      >
        <Listener />
      </SimulatorProvider>
    </LegacyThemeProvider>
  );
};

export { Simulator };
